import { config } from '@/pageConfig/home/nl/en';
import { HomePageTemplate } from '@/pageTemplate/HomePageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function HomePage() {
  const { trackEvent, trackDataForGtm } = useAnalyticsContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: we just one it on load so no need to add it as a dependency
  useEffect(() => {
    trackEvent('home_page.viewed');
    trackDataForGtm('homepage_viewed');
  }, []);

  return <HomePageTemplate config={config} />;
}
